export interface UserDetails {
  id: string;
  username: string;
  emailAddress: string;
  firstName: string;
  lastName: string;
  customerId: string;
  customerKey: string;
  customerName: string;
  storageFolder: string;
  disabled: boolean;
  amendOtherComments: boolean;
}
